export enum LANG_KEY {
  RU = 'ru-RU',
  KZ = 'kk-KZ'
}